import { CSSProperties, ReactNode } from 'react';
import {
  ListItem as MUIListItem,
  ListItemProps as MUIListItemProps,
} from '@mui/material';

type AtomMUIProps = {
  children?: ReactNode;
  style?: CSSProperties;
  disableGutters?: boolean;
  disablePadding?: boolean;
  secondaryAction?: ReactNode;
  onClick?: () => void;
  sx?: any;
};

export type ListItemProps = AtomMUIProps;

export const ListItem = (props: ListItemProps) => {
  const { style = {}, sx, ...data } = props;

  const MUIProps: MUIListItemProps = data;

  return <MUIListItem {...MUIProps} style={style} sx={sx} />;
};

export default ListItem;
